<template>
  <div class="error-configuration-page">
    <div class="error-configuration-page__row">
      <h1 class="pagetitle left">Superordinate rules</h1>

      <button
        class="btn btn-blue"
        v-on:click="showErrorCategoryEditor(selectedMetaruleTpl, 'add')"
      >
        Add new rule
      </button>

    </div>

    <div>
      <table >
        <thead>
          <tr>
            <th  >
              <div @click="sortByName" class=" cursor-pointer ds-fx">
                Name<div >{{ order.Name ? "▼" : "▲" }}</div>
              </div>
              <span></span>
            </th>

            <th  >
              <div @click="sortByCode" class=" cursor-pointer ds-fx">
                  Code<div >{{ order.Code ? "▼" : "▲" }}</div>
              </div>
               <span></span>
            </th>

            <th >
              <div @click="sortByNumber" class=" cursor-pointer ds-fx">
                Error points for the activated rule
                <div >{{
                  order.Number ? "▼" : "▲"
                }}</div>
              </div>
               <span></span>
            </th>

            <th>Control</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="metarule in metarules" :key="metarule.ID">
            <td>{{ metarule.Name }}</td>
            <td>{{ metarule.CodeName }}</td>
            <td>{{ metarule.GlobalErrorPoints }}</td>
            <td class="table__control">
              <button
                class="btn btn-blue"
                @click="showErrorCategoryEditor(metarule, 'edit')"
              >
                Edit
              </button>
              <button
                class="btn btn-red"
                @click="holderRemoveMetarule(metarule.ID, 'delete')"
              >
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <transition name="fade">
      <div class="modal-wrapper" v-if="showModalType">
        <div @click="showModalType = false" class="modal-backdrop"></div>
        <div class="modal-inner">

            <form
              class="form error-configuration-page-form"
              @submit.prevent="
                showModalType === 'add'
                  ? createMetarules()
                  : showModalType === 'edit'
                  ? updateMetarules()
                  : showModalType === 'delete'
                  ? deleteMetarules()
                  : ''
              "
            >
            <h2 v-if="showModalType === 'add'">Add new rule</h2>

            <h2 v-if="showModalType === 'edit'">Edit rule</h2>

            <h2 v-if="showModalType === 'delete'">Delete rule</h2>

            <div class="error-configuration-page-form__grid">

              <label class="error-configuration-page-form__grid--col1" for="firstname">Name</label>
              <input
                v-model.trim="selectedMetarule.Name"
                id="firstname"
                type="text"
                class="form-item form-item--input"
              />

              <label class="error-configuration-page-form__grid--col1" for="codename">Code Name</label>
              <input
                v-model.trim="selectedMetarule.CodeName"
                id="codename"
                type="text"
                class="form-item form-item--input"
              />

              <label class="error-configuration-page-form__grid--col1" for="global">Global Error Points</label>
              <input
                v-model.trim="selectedMetarule.GlobalErrorPoints"
                id="global"
                type="text"
                class="form-item form-item--input"
              />

            </div>

            <div class="error-configuration-page-form__btn-wrapper">
              <button type="submit" class="btn btn-blue">
                Save
              </button>

              <button
                @click="showModalType = false"
                type="button"
                class="btn btn-red"
              >
                Cancel
              </button>
            </div>

            </form>

            <button
              @click="showModalType = false"
              class="btn btn-onlytext close-modal"
            >
              <i class="fa fa-window-close" aria-hidden="true"></i>
            </button>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';

export default Vue.extend({
  data() {
    return {
      metarules: [],
      selectedMetarule: null,
      order: {
        Name: false,
        Code: false,
        Number: false,
      },
      showModalType: false,
      selectedMetaruleTpl: {
        ID: null,
        Name: '',
        CodeName: '',
        GlobalErrorPoints: null,
      },
    };
  },
  methods: {
    getMetarules() {
      Api.settings.superordinate.list().then((response) => {
        if (response.status == 200) {
          this.metarules = response.data;
        }
      });
    },
    createMetarules() {
      Api.settings.superordinate
        .create(this.selectedMetarule)
        .then((response) => {
          if (response.data.Status) {
            this.selectedMetarule = null;
            this.showModalType = false;
            this.metarules.push(response.data.SampleValue);
          } else {
            alert('something went wrong');
          }
        });
    },
    updateMetarules() {
      Api.settings.superordinate
        .update(this.selectedMetarule)
        .then((response) => {
          if (response.status === 200) {
            this.selectedMetarule = null;
            this.showModalType = false;
          } else {
            alert('something went wrong');
          }
        });
    },
    deleteMetarules() {
      Api.settings.superordinate
        .delete(this.selectedMetarule)
        .then((response) => {
          if (response.data.status === false) {
            return alert('Something goes wrong');
          }
          this.metarules.forEach((value, index) => {
            if (value.ID === this.selectedMetarule) {
              this.metarules.splice(index, 1);
              this.showModalType = false;
            }
          });
        });
    },
    showErrorCategoryEditor(object, type) {
      this.selectedMetarule = object;
      this.showModalType = type;
    },

    holderRemoveMetarule(id) {
      this.selectedMetarule = id;

      this.$modal.show('dialog', {
        title: 'Warning!',
        text: 'Delete this metarule?',
        buttons: [
          {
            title: 'Yes',
            handler: () => {
              this.deleteMetarules();
              this.$modal.hide('dialog');
            },
          },
          {
            title: 'No',
          },
        ],
      });
    },

    sortByNumber() {
      this.metarules.sort((a, b) => {
        if (this.order.Number === false) {
          return a.GlobalErrorPoints - b.GlobalErrorPoints;
        } else {
          return b.GlobalErrorPoints - a.GlobalErrorPoints;
        }
      });
      this.order.Number = !this.order.Number;
    },
    sortByCode() {
      this.metarules.sort((a, b) => {
        if (this.order.Code === false) {
          return a.CodeName.localeCompare(b.CodeName);
        } else {
          return b.CodeName.localeCompare(a.CodeName);
        }
      });
      this.order.Code = !this.order.Code;
    },
    sortByName() {
      this.metarules.sort((a, b) => {
        if (this.order.Name === false) {
          return a.Name.localeCompare(b.Name);
        } else {
          return b.Name.localeCompare(a.Name);
        }
      });
      this.order.Name = !this.order.Name;
    },
  },
  created() {
    this.getMetarules();
  },
});
</script>

<style lang="scss">
.error-configuration-page {
  padding-right: 25px;

  &__row {
    display: flex;
    justify-content: space-between;

    .btn {
      margin: 7px 0;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  table {
    min-width: 1100px;
    margin: 21px;
    margin-left: 0;
    background: #fff;
    padding: 11px;
    border-collapse: collapse;

    .ds-fx {
      display: flex;
    }

    .table__control {
      display: flex;
      justify-content: flex-start;
      button {
        margin-right: 21px;
      }
    }

    thead {
      tr {
        background: #0075b1;
        color: #fff;
      }
      th {
        font-weight: 300;
        padding: 21px;
        padding-left: 11px;
        text-align: start;
        position: relative;

        span {
          height: 90%;
          border-right: 1px solid #ebebeb25;
          position: absolute;
          right: 0;
          top: 3px;
        }
      }
    }

    tbody {
      td {
        border-bottom: 1px solid #ebebeb;
        border-right: 1px solid #ebebeb;
      }
    }

    th,
    td {
      margin: 0;
      padding: 0;
    }

    td {
      padding: 11px;
      text-align: start;
    }
  }
}

.disabled {
  opacity: 0.2;
}

.modal-wrapper .modal-inner .close-modal {
  display: block;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 15px;
  height: 15px;
  transition: all 0.2s ease;

  &:hover {
    color: #000;
  }
}
.modal-wrapper .modal-inner .close-modal:hover {
  opacity: 0.7;
}

.modal-backdrop {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 9;
}
.modal-inner {
  position: relative;
  z-index: 999;
}
.center {
  text-align: center;
}
.error-configuration-page-form {
  width: 100%;
  padding: 20px 60px;

  h2 {
    margin-bottom: 52px;
  }

  input {
    background: #ebebeb;
  }

  &__grid {
    display: grid;
    grid-template-columns: 200px 300px;
    row-gap: 31px;
    margin-bottom: 59px;

    &--col1 {
      grid-column: 1;
      display: flex;
      align-items: flex-start;
    }
  }

  &__btn-wrapper {
    display: flex;

    .btn {
      width: 99px;
      margin-right: 21px;
    }
  }
}
.error-configuration-page-row {
  display: block;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #b5b5b5;
}
.error-configuration-page-row:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
